import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MutualIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.5 6c-1.31 0-2.51.42-3.5 1.14A5.977 5.977 0 008.5 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c1.31 0 2.51-.42 3.5-1.14.99.71 2.19 1.14 3.5 1.14 3.31 0 6-2.69 6-6s-2.69-6-6-6zm-4 6c0-.69.19-1.33.5-1.9.31.57.5 1.21.5 1.9s-.19 1.33-.5 1.9c-.31-.57-.5-1.21-.5-1.9zm-7 0c0-2.21 1.79-4 4-4 .76 0 1.46.22 2.07.59C9.9 9.56 9.5 10.73 9.5 12s.4 2.44 1.07 3.41c-.61.37-1.31.59-2.07.59-2.21 0-4-1.79-4-4zm11 4c-.76 0-1.46-.22-2.07-.59.67-.97 1.07-2.14 1.07-3.41s-.4-2.44-1.07-3.41c.61-.37 1.31-.59 2.07-.59 2.21 0 4 1.79 4 4s-1.79 4-4 4z"
                    })
                })
            })
        ]
    });
};
MutualIcon.isCarinaIcon = true;
export default MutualIcon;
